import "@mui/styles";
import {
  createTheme,
  CssBaseline,
  ThemeProvider,
  Theme,
  StyledEngineProvider,
  adaptV4Theme,
} from "@mui/material";
import PrivateRoute from "components/privateRoute";
import UploadManager from "components/UploadManager/UploadManager";
import { GlobalStyles } from "config/globalStyles";
import { DarkTheme, LightTheme } from "config/themes";
import AppScreen from "pages/app";
import LoginScreen from "pages/auth/login/login.screen";
import {
  //HashRouter as Router,
  Redirect,
  Switch,
  Route,
  HashRouter, //replaced with HashRouter
} from "react-router-dom";
import AuthService from "services/AuthService";
import { useThemeDetector } from "utils/helpers";
import React, { useEffect, useRef } from "react";
import TokenExpiredComponent from "pages/auth/login/tokenExpired.screen";
import { getKeycloakAuthConfig } from "config/keycloak";
interface UserLoggedOutEventDetail {
  loggedOut: boolean;
}
type UserLoggedOutEvent = CustomEvent<UserLoggedOutEventDetail>;

declare module "@mui/styles/defaultTheme" {
  // eslint-disable-next-line @typescript-eslint/no-empty-interface
  interface DefaultTheme extends Theme {}
}

export default function Splash() {
  const params = getKeycloakAuthConfig();
  const authRef = useRef<HTMLElement | null>(null);
  const isDarkTheme = useThemeDetector();
  const appliedTheme = createTheme(adaptV4Theme(isDarkTheme ? DarkTheme : LightTheme));

  const handleUserLoggedOut = async event => {
    // if (event?.detail?.loggedOut) await logout();
  };

  useEffect(() => {
    import("hfn-auth-legacy/dist/main");
  });

  useEffect(() => {
    authRef.current = document.querySelector(
      "hfn-auth",
    ) as HTMLElement | null;
    const listener = (event: Event) =>
      handleUserLoggedOut(event as UserLoggedOutEvent);
    if (authRef.current) {
      authRef.current.addEventListener("userLoggedOut", listener as EventListener);
    }
    return () => {
      if (authRef.current) {
        authRef?.current?.removeEventListener("userLoggedOut", listener as EventListener);
      }
    };
  }, [authRef]);

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider theme={appliedTheme}>
        <CssBaseline />
        <hfn-auth
            ref={authRef}
            config={JSON.stringify(params)}
            showCancel
            authType="on-demand"
            redirectUrl="home"
            additionalParam={`&hidereg=on`}
          />
        <GlobalStyles />
        <HashRouter>
          <AuthService>
            <Switch>
              <Route exact path={"/"}>
                <Redirect to={`/login`} />
              </Route>
              <Route path="/login" component={LoginScreen} />
              <Route path="/session-expired" component={TokenExpiredComponent} />
              <PrivateRoute path="/app" component={AppScreen} />
            </Switch>
          </AuthService>
        </HashRouter>
        <UploadManager />
      </ThemeProvider>
    </StyledEngineProvider>
  );
}
